import { render, staticRenderFns } from "./CommonForm.vue?vue&type=template&id=0b39c722&"
import script from "./CommonForm.vue?vue&type=script&lang=js&"
export * from "./CommonForm.vue?vue&type=script&lang=js&"
import style0 from "./CommonForm.vue?vue&type=style&index=0&id=0b39c722&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports